import React, { useState } from "react";
import { toast } from "react-toastify";

import { Button, Card } from "semantic-ui-react";
import Switch from "./Switch";

function Import(props) {
    const [fileStatus, setFileStatus] = useState(false);
    const [switchBackground, setSwitchBackground] = useState(false);
    const [switchFavorites, setSwitchFavorites] = useState(false);
    const [switchSettings, setSwitchSettings] = useState(false);
    const [backgroundData, setBackgroundData] = useState(null);
    const [favoritesData, setFavoritesData] = useState(null);
    const [settingsData, setSettingsData] = useState(null);
    const lang = props.lang;

    function handleChangeFile(e) {
        const fileExtension = e.target.files[0].name.split(".");
        if (fileExtension[fileExtension.length - 1] === "json") {
            const reader = new FileReader();
            reader.onload = async (e) => {
                if (e.target.result) {
                    let fileJson = JSON.parse(e.target.result);
                    if (fileJson.hasOwnProperty("background")) {
                        setBackgroundData({
                            id: "backgroundImport",
                            description: { es: "Importar fondos: ", us: "Import backgrounds: " },
                            option_1: { es: "No", us: "No" },
                            option_2: { es: "Si", us: "Yes" },
                            value: true,
                            data: fileJson.background,
                        });
                        setSwitchBackground(true);
                    } else {
                        setBackgroundData(null);
                        setSwitchBackground(false);
                    }
                    if (fileJson.hasOwnProperty("favorites")) {
                        setFavoritesData({
                            id: "favoritesImport",
                            description: { es: "Importar favoritos: ", us: "Import favorites: " },
                            option_1: { es: "No", us: "No" },
                            option_2: { es: "Si", us: "Yes" },
                            value: true,
                            data: fileJson.favorites,
                        });
                        setSwitchFavorites(true);
                    } else {
                        setFavoritesData(null);
                        setSwitchFavorites(false);
                    }
                    if (fileJson.hasOwnProperty("settings")) {
                        setSettingsData({
                            id: "settingsImport",
                            description: { es: "Importar configuración: ", us: "Import settings: " },
                            option_1: { es: "No", us: "No" },
                            option_2: { es: "Si", us: "Yes" },
                            value: true,
                            data: fileJson.settings,
                        });
                        setSwitchSettings(true);
                    } else {
                        setSettingsData(null);
                        setSwitchSettings(false);
                    }
                    setFileStatus(true);
                    toast.success((props.lang === "es") ? 'Archivo cargado correctamente (' + fileExtension.join(".") + ')' : 'File uploaded successfully (' + fileExtension.join(".") + ')', {
                        position: "top-center",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            };
            reader.readAsText(e.target.files[0]);
        } else {
            toast.error((props.lang === "es") ? 'Extensión de archivo invalida (.json)' : 'Invalid extension file (.json)', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
        e.target.value = '';
    }

    function handleChangeSwitch(id, value) {
        if (id === "backgroundImport") {
            setSwitchBackground(value);
            backgroundData.value = value;
        } else if (id === "favoritesImport") {
            setSwitchFavorites(value);
            favoritesData.value = value;
        } else if (id === "settingsImport") {
            setSwitchSettings(value);
            settingsData.value = value;
        }
    }

    function handleClickImportData() {
        if (switchBackground) {
            for (const key in backgroundData.data) {
                if (Object.hasOwnProperty.call(backgroundData.data, key)) {
                    if (Array.isArray(backgroundData.data[key])) {
                        localStorage.setItem(key, JSON.stringify(backgroundData.data[key]));
                    } else {
                        localStorage.setItem(key, backgroundData.data[key]);
                    }
                }
            }
        }
        if (switchFavorites) {
            for (const key in favoritesData.data) {
                if (Object.hasOwnProperty.call(favoritesData.data, key)) {
                    if (Array.isArray(favoritesData.data[key])) {
                        localStorage.setItem(key, JSON.stringify(favoritesData.data[key]));
                    } else {
                        localStorage.setItem(key, favoritesData.data[key]);
                    }
                }
            }
        }
        if (switchSettings) {
            for (const key in settingsData.data) {
                if (Object.hasOwnProperty.call(settingsData.data, key)) {
                    if (Array.isArray(settingsData.data[key])) {
                        localStorage.setItem(key, JSON.stringify(settingsData.data[key]));
                    } else {
                        localStorage.setItem(key, settingsData.data[key]);
                    }
                }
            }
        }
        props.onChangeImport(switchBackground, switchFavorites, switchSettings);
        toast.success((props.lang === "es") ? 'Importación finalizada' : 'Import finished', {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });
    }

    return (
        <div className="col" style={{ width: "100%" }} id={props.data.id}>
            <p style={{ margin: "auto auto .6em" }}>{props.data.description[lang]}</p>
            {(fileStatus) ?
                <>
                    {(backgroundData) ? <Card className="option-card-settings" fluid color='red' header={<Switch onChange={handleChangeSwitch} lang={lang} data={backgroundData} />} /> : null}
                    {(favoritesData) ? <Card className="option-card-settings" fluid color='red' header={<Switch onChange={handleChangeSwitch} lang={lang} data={favoritesData} />} /> : null}
                    {(settingsData) ? <Card className="option-card-settings" fluid color='red' header={<Switch onChange={handleChangeSwitch} lang={lang} data={settingsData} />} /> : null}
                    <Card className="option-card-settings" fluid color='red' header={
                        <>
                            <input type="file" style={{ display: "none" }} id="btnImport" onChange={handleChangeFile} />
                            <label htmlFor="btnImport" className="ui large fluid primary button">{(props.lang === "es") ? 'Importar otro archivo' : 'Import other file'}</label>
                            <Button style={{ margin: "0", width: "100%" }} primary content={(props.lang === "es") ? 'Importar información' : "Import data"} size="large" onClick={handleClickImportData} />
                        </>
                    } />
                </>
                :
                <Card className="option-card-settings" fluid color='red' header={
                    <>
                        <input type="file" style={{ display: "none" }} id="btnImport" onChange={handleChangeFile} />
                        <label htmlFor="btnImport" className="ui large fluid primary button">{(props.lang === "es") ? 'Importar archivo' : 'Import file'}</label>
                    </>
                } />
            }
        </div>
    );
}

export default Import;